import { render } from "./checkTitle.vue?vue&type=template&id=4fc6893a&scoped=true&ts=true"
import script from "./checkTitle.vue?vue&type=script&lang=ts"
export * from "./checkTitle.vue?vue&type=script&lang=ts"

import "./checkTitle.vue?vue&type=style&index=0&id=4fc6893a&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc6893a"]])

export default __exports__